<template>
    <p class="bs-page-description">
        <slot></slot>
    </p>
</template>

<style lang="scss">
.bs-page-description {
    font-size: 0.875rem;
    color: var(--bs-page-description-color);
}
</style>